
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[state]",
      function () {
        return require("private-next-pages/s/[state].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[state]"])
      });
    }
  